import { useEffect, useState } from 'react';
import { fetchCustomerContext } from '../services/customerContextApi';

interface UseCustomerHasMonthlyInvoiceScheduleResult {
  hasMonthlyInvoiceSchedule: boolean | null;
  loading: boolean;
}

export function useCustomerHasMonthlyInvoiceSchedule(
  dataverseCustomerId: string | undefined | null,
): UseCustomerHasMonthlyInvoiceScheduleResult {
  const [value, setValue] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!dataverseCustomerId) {
      setValue(null);
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    setLoading(true);
    fetchCustomerContext(dataverseCustomerId, controller.signal)
      .then((ctx) => {
        setValue(ctx.hasMonthlyInvoiceSchedule === true);
      })
      .catch((err) => {
        if (err?.name === 'AbortError') return;
        setValue(false);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [dataverseCustomerId]);

  return { hasMonthlyInvoiceSchedule: value, loading };
}
